import * as angular from 'angular';
import { IValueViewModel } from '../../models';
import { WidgetType } from '../widgetTypes';
import { IWidget } from './IWidget';
import { IWidgetConfiguration } from './IWidgetConfiguration';

export interface IWidgetBaseScope extends angular.IScope {
    vm: WidgetBase;
}

export class WidgetBase implements IWidget {
    static controllerId = 'WidgetBase';

    applicationName: string;
    backgroundColor: string;
    baseType?: string;
    col: number;
    configuration: IWidgetConfiguration = { configuration: {} };
    currentValue: number;
    dashboardLink: string;
    guid: string;
    isTitleHidden: boolean;
    map?: any;
    name: string;
    row: number;
    showBottomMargin: boolean;
    showLeftMargin: boolean;
    showRightMargin: boolean;
    showTopMargin: boolean;
    sizeX: number;
    sizeY: number;
    type: WidgetType | string;
    viewModels: IValueViewModel[];

    setConfiguration(c: IWidgetConfiguration): void {
        if (c) {
            this.configuration = c;

            if (c.sizeX) {
                this.sizeX = c.sizeX;
            }
            if (c.sizeY) {
                this.sizeY = c.sizeY;
            }
            if (c.col) {
                this.col = c.col;
            }
            if (c.row) {
                this.row = c.row;
            }
            if (c.guid) {
                this.guid = c.guid;
            }
            if (c.name) {
                this.name = c.name;
            }
            if (c.applicationName) {
                this.applicationName = c.applicationName;
            }
            if (c.configuration) {
                this.configuration = c.configuration;
            }

            this.backgroundColor = c.backgroundColor;
            this.dashboardLink = c.dashboardLink;
        }
    }

    sanitize(): void {
        if (this.isTitleHidden === undefined) {
            this.isTitleHidden = false;
        }
    }

    static serialize(w: IWidget): any {
        const self = w;
        const result: any = {
            //configuration: self.configuration ? JSON.stringify(self.configuration) : undefined,
            row: self.row,
            col: self.col,
            sizeY: self.sizeY,
            sizeX: self.sizeX,
            isTitleHidden: w.isTitleHidden,
            name: self.name,
            backgroundColor: self.backgroundColor,
            dashboardLink: self.dashboardLink,
            'type': self.type,
            guid: self.guid,
            applicationName: self.applicationName,
            showLeftMargin: self.showLeftMargin === undefined ? true : self.showLeftMargin,
            showRightMargin: self.showRightMargin === undefined ? true : self.showRightMargin,
            showTopMargin: self.showTopMargin === undefined ? true : self.showTopMargin,
            showBottomMargin: self.showBottomMargin === undefined ? true : self.showBottomMargin,
        };

        if (self.configuration) {
            result.configuration = JSON.stringify(self.configuration);
        }

        return result;
    }

    static copy(widget: IWidget): IWidget {
        const newWidget = {
            sizeX: widget.sizeX,
            sizeY: widget.sizeY,
            row: widget.row,
            col: widget.col,
            name: widget.name,
            backgroundColor: widget.backgroundColor,
            dashboardLink: widget.dashboardLink,
            configuration: widget.configuration,
            guid: widget.guid,
            viewModels: angular.copy(widget.viewModels),
            tagDefinitionGuid: widget.tagDefinitionGuid,
            isTitleHidden: widget.isTitleHidden,
            series: angular.copy(widget.series),
            data: widget.data,
            map: widget.map,
            currentValue: widget.currentValue,
            applicationName: widget.applicationName,

            showLeftMargin: widget.showLeftMargin === undefined ? true : widget.showLeftMargin,
            showRightMargin: widget.showRightMargin === undefined ? true : widget.showRightMargin,
            showTopMargin: widget.showTopMargin === undefined ? true : widget.showTopMargin,
            showBottomMargin: widget.showBottomMargin === undefined ? true : widget.showBottomMargin,

            // highlights: angular.copy(widget.highlights),
            // icon: widget.icon,
            // type: widget.type,
            // hasExtendedProperties: widget.hasExtendedProperties
        } as IWidget;
        // Special properties mapped in UI for typed widgets
        const props = ['highlights', 'icon', 'type', 'hasExtendedProperties'];
        props.forEach(p => {
            if (widget.hasOwnProperty(p)) {
                newWidget[p] = angular.copy(widget[p]);
            }
        });
        return newWidget;
    }
}